import React, { useState } from "react";
import { useApplication } from "./ApplicationProvider";

export function SaveAndContinueButton() {
  const { data, ensureDraft } = useApplication();
  const [status, setStatus] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [message, setMessage] = useState<string>("");

  const canSave =
    /.+@.+\..+/.test(data.step2.studentEmail) && /.+@.+\..+/.test(data.step2.parentEmail);

  const onClick = async () => {
    setStatus("sending");

    // Step 1: make sure the server draft exists and holds the latest data.
    let token: string | null = null;
    try {
      token = await ensureDraft();
    } catch {
      token = null;
    }
    if (!token) {
      // The SERVER save itself didn't happen — only here is the work limited
      // to this device.
      setStatus("error");
      setMessage(
        "Could not reach the server right now. Your progress is saved on this device — please try again shortly."
      );
      return;
    }

    // Step 2: email the magic link to the student + parent.
    try {
      const res = await fetch(`/api/drafts/${encodeURIComponent(token)}/save-link`, {
        method: "POST",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setStatus("sent");
      setMessage(
        `A resume link has been emailed to ${data.step2.studentEmail} and ${data.step2.parentEmail}. ` +
          `Use it to continue on any device.`
      );
    } catch {
      // The draft IS saved on the server — only the email failed.
      setStatus("error");
      setMessage(
        "Your progress is saved. We couldn't email the resume link right now — please try again in a few minutes."
      );
    }
  };

  if (!canSave) {
    return (
      <div className="text-xs text-slate-500">
        Enter a student email and a parent/guardian email above to enable "Save &amp; continue later".
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1">
      <button
        type="button"
        onClick={onClick}
        disabled={status === "sending"}
        className="btn-secondary text-sm"
      >
        {status === "sending" ? "Sending…" : "Save & continue later"}
      </button>
      {status !== "idle" && status !== "sending" && (
        <p className={`text-xs ${status === "error" ? "text-red-600" : "text-slate-600"}`}>{message}</p>
      )}
    </div>
  );
}
